export class DetailFormatterController {
  public static $inject = ['$rootScope', '$scope', '$translate'];

  constructor(
    private $rootScope: ng.IRootScopeService,
    private $scope: ng.IScope,
    private $translate: ng.translate.ITranslateService
  ) {
  }

  public formatCurrencyString = (currencyString: string) => {
    const formattedCurrency = (parseFloat(currencyString) / 100).toFixed(2);
    return `${this.$translate.instant('CURRENCY_SYMBOL')}${formattedCurrency}`;
  }
}